import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { TableCell, TableRow } from '@mui/material';
import { PatientOrders } from 'models/patient';
import { useTranslation } from 'react-i18next';

type PatientOrdersItemProps = {
    patientOrders: PatientOrders;
};
const PatientOrdersItem: FC<PatientOrdersItemProps> = ({ patientOrders }: PatientOrdersItemProps) => {
    const navigate = useNavigate();
    const { t: translate } = useTranslation(['patient', 'orders']);

    const navigateToHistory = () => {
        navigate(`/patients/${patientOrders._id}`);
    };
    return (
        <TableRow sx={{ cursor: 'pointer' }} hover onClick={navigateToHistory}>
            <TableCell>
                {patientOrders.patient.firstName} {patientOrders.patient.lastName}
            </TableCell>
            <TableCell className="mouseflow-mask">{patientOrders.patient.personalIdentityNumber}</TableCell>
            <TableCell>{translate(patientOrders.patient.category)}</TableCell>
            <TableCell>
                {patientOrders.orderCount} {translate('orders:ORDERS').toLowerCase()}
            </TableCell>
        </TableRow>
    );
};

export default PatientOrdersItem;
